const WIDGET_SELECTOR = ".dashboard-widget[data-widget-id]";
const REMOVE_BUTTON_SELECTOR = "[data-dashboard-remove]";
const DRAGGING_CLASS = "dashboard-widget-dragging";
const DRAG_OVER_CLASS = "dashboard-widget-drag-over";

const csrfToken = () => document.querySelector("meta[name='csrf-token']")?.content;

const currentWidgetOrder = (container) =>
  Array.from(container.querySelectorAll(WIDGET_SELECTOR)).map((widget) => widget.dataset.widgetId);

const saveVisibleWidgets = async (container) => {
  const saveUrl = container.dataset.dashboardWidgetsUrl;
  if (!saveUrl) return;

  try {
    await fetch(saveUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
      body: JSON.stringify({ widget_ids: currentWidgetOrder(container) }),
      credentials: "same-origin",
    });
  } catch (error) {
    console.error("Erro ao salvar visibilidade do dashboard:", error);
  }
};

const ensureEmptyState = (container) => {
  const hasWidgets = container.querySelector(WIDGET_SELECTOR);
  const existingEmptyState = container.querySelector(".dashboard-empty-state");

  if (hasWidgets) {
    if (existingEmptyState) existingEmptyState.remove();
    return;
  }

  if (!existingEmptyState) {
    const emptyState = document.createElement("div");
    emptyState.className = "dashboard-empty-state alert alert-light border text-muted w-100 mb-0";
    emptyState.textContent = 'Nenhum card selecionado. Clique em "Personalizar cards" para mostrar os cards desejados.';
    container.appendChild(emptyState);
  }
};

const saveWidgetOrder = async (container) => {
  const saveUrl = container.dataset.dashboardSortUrl;
  if (!saveUrl) return;

  try {
    await fetch(saveUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
      body: JSON.stringify({ order: currentWidgetOrder(container) }),
      credentials: "same-origin",
    });
  } catch (error) {
    console.error("Erro ao salvar ordem do dashboard:", error);
  }
};

const closestWidget = (target) => target?.closest?.(WIDGET_SELECTOR);

export const initDashboardLayout = () => {
  const container = document.querySelector("[data-dashboard-widgets]");
  if (!container || container.dataset.dashboardLayoutBound === "true") return;

  container.dataset.dashboardLayoutBound = "true";

  let draggingWidget = null;

  container.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
    widget.setAttribute("draggable", "true");

    widget.addEventListener("dragstart", (event) => {
      draggingWidget = widget;
      widget.classList.add(DRAGGING_CLASS);
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", widget.dataset.widgetId || "");
    });

    widget.addEventListener("dragend", async () => {
      widget.classList.remove(DRAGGING_CLASS);
      container.querySelectorAll(`.${DRAG_OVER_CLASS}`).forEach((item) => item.classList.remove(DRAG_OVER_CLASS));
      await saveWidgetOrder(container);
      draggingWidget = null;
    });

    const removeButton = widget.querySelector(REMOVE_BUTTON_SELECTOR);
    if (removeButton) {
      removeButton.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (draggingWidget === widget) {
          draggingWidget = null;
        }

        widget.remove();
        ensureEmptyState(container);

        await saveWidgetOrder(container);
        await saveVisibleWidgets(container);
      });
    }
  });

  container.addEventListener("dragover", (event) => {
    event.preventDefault();
    if (!draggingWidget) return;

    const targetWidget = closestWidget(event.target);
    if (!targetWidget || targetWidget === draggingWidget) return;

    container.querySelectorAll(`.${DRAG_OVER_CLASS}`).forEach((item) => item.classList.remove(DRAG_OVER_CLASS));
    targetWidget.classList.add(DRAG_OVER_CLASS);

    const targetRect = targetWidget.getBoundingClientRect();
    const insertAfter = event.clientY > targetRect.top + targetRect.height / 2;
    container.insertBefore(draggingWidget, insertAfter ? targetWidget.nextSibling : targetWidget);
  });

  container.addEventListener("drop", (event) => {
    event.preventDefault();
    container.querySelectorAll(`.${DRAG_OVER_CLASS}`).forEach((item) => item.classList.remove(DRAG_OVER_CLASS));
  });

  ensureEmptyState(container);
};
